import { createContext } from 'react';
import { User } from './user';
import { Vertical } from './vertical';
import { SupportBU } from './supportBU';

export type UserAction = { type: 'SET_USER' };
export type AccessTokenAction = { type: 'SET_ACCESS_TOKEN' };
export type Dispatch = (action: UserAction | AccessTokenAction) => void;
export const UserContext = createContext<User | null>(null);
export const UserDispatchContext = createContext<Dispatch | null>(null);

export type VerticalAction = { type: 'SET_VERTICAL' };
export type VerticalDispatch = (action: VerticalAction) => void;
export const VerticalContext = createContext<Vertical | null>(null);
export const VerticalDispatchContext = createContext<VerticalDispatch | null>(
  null
);

export type SupportBUAction = { type: 'SET_SUPPORTBU' };
export type SupportBUDispatch = (action: SupportBUAction) => void;
export const SupportBUContext = createContext<SupportBU | null>(null);
export const SupportBUDispatchContext = createContext<SupportBUDispatch | null>(
  null
);
